import Model, { belongsTo, attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type SubscriptionUtilisation from 'teacher-ui-client/models/subscription-utilisation'
import type School from 'teacher-ui-client/models/school'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type StringTransform from 'teacher-ui-client/transforms/string'
import type DateTransform from 'teacher-ui-client/transforms/date'
import type BooleanTransform from 'teacher-ui-client/transforms/boolean'

export const CAPACITY_UNLIMITED = 'unlimited'

export type SubscriptionStatus = 'pending' | 'expired' | 'active'

export default class SchoolSubscription extends Model {
  @attr<StringTransform>('string') declare softCapacity: string // comes down as "unlimited" or something like "1200"

  @attr<StringTransform>('string') declare subscriptionType: SubscriptionType

  @attr<StringTransform>('string') declare subscriptionName: string

  // date transform expects ISO8601 format, backend provides as yyyy-MM-dd format which is technically still ISO8601

  @attr<DateTransform>('date') declare startDate: Date

  @attr<DateTransform>('date') declare endDate: Date

  @attr<StringTransform>('string') declare status: SubscriptionStatus

  @attr<BooleanTransform>('boolean') declare isTrial: boolean

  @belongsTo<SubscriptionUtilisation>('subscription-utilisation', { async: false, inverse: 'schoolSubscription' })
  declare subscriptionUtilisation?: SubscriptionUtilisation

  @belongsTo<School>('school', { async: false, inverse: 'schoolSubscriptions' })
  declare school?: School

  get isPending() {
    return this.status === 'pending'
  }

  get isExpired() {
    return this.status === 'expired'
  }

  get isActive() {
    return this.status === 'active'
  }

  [Type] = 'school-subscription' as const
}
